<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" *ngIf="mindConditions.length > 0 && bodyConditions.length > 0">
  <div class="d-flex flex-fill my-4 zaya-form-help-text" i18n="label|Help text for the issues a practitioner specializes in.@@labelApplicationIssuesHelpText">
    Use the dropdown list below, please include any conditions you specialize in treating within your practice. If you do not see your symptom or condition listed, please make
    sure to choose "Other" in order to type in the name of the condition. Please make sure to double check your spelling and grammar.
  </div>
  <div class="row" *ngFor="let conditionControl of getControls('conditions'); let i = index;">
    <div class="col-xs-12 col-md-3">
      <div formArrayName="conditionCategories">
        <label for="category{{i}}" class="zaya-form-sub-header" i18n="label|The category of the condition a practitioner practices.@@labelConditionCategory" *ngIf="i === 0">Condition Category</label>
        <select name="category{i}}" id="category{{i}}" class="form-control" (change)="updateConditionCategory(i, $event.target.value)" id="conditionCategorySelect{{i}}">
          <option value="body">Body</option>
          <option value="mind">Mind</option>
        </select>
        <span
          class="help-block"
          *ngIf="i == 0 && formGroup.get('conditionCategories.0').invalid && formGroup.get('conditionCategories.0').touched"
          i18n="error message|The message shown when a condition category has not been entered.@@errorConditionCategory">
            Please enter at least 1 condition category.
        </span>
      </div>
    </div>
    <div class="col-xs-12 col-md-9 form-group">
      <div formArrayName="conditions">
        <label for="condition{{i}}" class="zaya-form-sub-header" i18n="label|The condition a practitioner specializes in.@@labelCondition" *ngIf="i === 0">Conditions you specialize in</label>
        <select class="form-control" (change)="updateCondition(i, $event.target.value)" id="conditionSelect{{i}}">
          <option *ngFor="let condition of formGroup.get('conditionCategories.' + i).value === 'mind' ? mindConditions : bodyConditions" [value]="condition">
            {{condition}}
          </option>
        </select>
        <input id="condition{{i}}" type="text" class="form-control col-xs-12 mt-3" [formControlName]="i" hidden>
        <span
          class="help-block"
          *ngIf="i == 0 && formGroup.get('conditions.0').invalid && formGroup.get('conditions.0').touched"
          i18n="error message|The message shown when a condition has not been entered.@@errorCondition">
            Please enter at least 1 condition.
        </span>
        <div class="text-right" *ngIf="i > 0">
          <span class="zaya-form-link" (click)="onRemoveControl('conditionCategories', i); onRemoveControl('conditions', i)">
            x <ng-container i18n="button|Used to remove a condition the practitioner has entered.@@buttonRemoveCondition">Remove this condition</ng-container>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center" style="margin-bottom: 30px;">
    <span
      class="zaya-form-link"
      (click)="onAddControl('conditionCategories'); onAddControl('conditions')">
      + <ng-container i18n="button|Used to add a condition.@@buttonAddCondition">Add another condition</ng-container>
    </span>
  </div>

  <hr>

  <div class="d-flex flex-fill justify-content-center">
    <button type="submit" class="btn btn-primary modal-btn mr-2" [disabled]="!formGroup.valid || isLoading">Submit</button>
    <button type="button" class="btn btn-secondary modal-btn" (click)="onDismiss()">Cancel</button>
  </div>
</form>
